// Train Horn Drill — page interactivity (null-safe, runs on every template)

(function () {
  // ---------- Footer year
  const yearEl = document.getElementById('year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  // ---------- Countdown (rolling 23:59:59 demo)
  const cdH = document.getElementById('cd-h');
  const cdM = document.getElementById('cd-m');
  const cdS = document.getElementById('cd-s');
  if (cdH && cdM && cdS) {
    function tick() {
      const now = new Date();
      const end = new Date(now);
      end.setHours(23, 59, 59, 999);
      const diff = end - now;
      cdH.textContent = String(Math.floor(diff / 3600000)).padStart(2, '0');
      cdM.textContent = String(Math.floor(diff / 60000) % 60).padStart(2, '0');
      cdS.textContent = String(Math.floor(diff / 1000) % 60).padStart(2, '0');
    }
    tick();
    setInterval(tick, 1000);
  }

  // ---------- Gallery (only on product pages)
  const stage = document.getElementById('gallery-stage');
  if (!stage) return; // bail out gracefully — no gallery on this page
  const slides = stage.querySelectorAll('img');
  const dotsEl = document.getElementById('gallery-dots');
  const thumbsEl = document.getElementById('thumbs');
  let active = 0;

  // build dots / thumbs only if their containers exist & are empty
  if (dotsEl && dotsEl.children.length === 0) {
    slides.forEach((_, i) => {
      const dot = document.createElement('span');
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => go(i));
      dotsEl.appendChild(dot);
    });
  }
  if (thumbsEl && thumbsEl.children.length === 0) {
    slides.forEach((img, i) => {
      const b = document.createElement('button');
      if (i === 0) b.classList.add('active');
      b.innerHTML = `<img src="${img.src}" alt="">`;
      b.addEventListener('click', () => go(i));
      thumbsEl.appendChild(b);
    });
  }
  function go(i) {
    if (slides[active]) slides[active].classList.remove('active');
    if (dotsEl && dotsEl.children[active]) dotsEl.children[active].classList.remove('active');
    if (thumbsEl && thumbsEl.children[active]) thumbsEl.children[active].classList.remove('active');
    active = (i + slides.length) % slides.length;
    if (slides[active]) slides[active].classList.add('active');
    if (dotsEl && dotsEl.children[active]) dotsEl.children[active].classList.add('active');
    if (thumbsEl && thumbsEl.children[active]) thumbsEl.children[active].classList.add('active');
  }
  document.querySelectorAll('.gallery__arrow--prev').forEach((b) => b.addEventListener('click', () => go(active - 1)));
  document.querySelectorAll('.gallery__arrow--next').forEach((b) => b.addEventListener('click', () => go(active + 1)));

  // ---------- Touch swipe on the gallery
  const gallery = document.querySelector('.gallery');
  if (gallery && 'ontouchstart' in window) {
    let startX = 0, startY = 0, startT = 0, dragging = false;
    const SWIPE_MIN = 40;     // px — minimum horizontal distance to count as a swipe
    const SWIPE_MAX_T = 600;  // ms — anything slower is a scroll, not a swipe
    const SWIPE_AXIS_RATIO = 1.4; // horizontal must be 1.4× vertical to fire

    gallery.addEventListener('touchstart', (e) => {
      const t = e.changedTouches[0];
      startX = t.clientX; startY = t.clientY; startT = Date.now();
      dragging = true;
      stage.style.transition = 'none';
    }, { passive: true });

    gallery.addEventListener('touchmove', (e) => {
      if (!dragging) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      // only start visually following the finger if motion is clearly horizontal
      if (Math.abs(dx) > Math.abs(dy)) {
        const img = slides[active];
        if (img) img.style.transform = `translateX(${dx * 0.4}px)`;
      }
    }, { passive: true });

    gallery.addEventListener('touchend', (e) => {
      if (!dragging) return;
      dragging = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - startX;
      const dy = t.clientY - startY;
      const dt = Date.now() - startT;
      // reset any visual drag offset
      slides.forEach((s) => { s.style.transform = ''; s.style.transition = ''; });
      stage.style.transition = '';

      if (dt > SWIPE_MAX_T) return;
      if (Math.abs(dx) < SWIPE_MIN) return;
      if (Math.abs(dx) < Math.abs(dy) * SWIPE_AXIS_RATIO) return;

      if (dx < 0) go(active + 1); else go(active - 1);
    });
  }

  // ---------- Variant option pickers
  document.querySelectorAll('.opts__row').forEach((row) => {
    const group = row.dataset.group;
    row.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-val]');
      if (!btn) return;
      row.querySelectorAll('[data-val]').forEach((x) => x.classList.remove('active'));
      btn.classList.add('active');
      const labelTarget = document.getElementById(`opt-${group}`);
      if (labelTarget) labelTarget.textContent = btn.dataset.val;
      updatePrice();
    });
  });

  // ---------- Trumpets price modifier (applied on top of color × kit base price)
  const TRUMPET_DELTA = { 'Dual': -50, 'Quad': -25, 'Boss Series': 0 };

  // pricing matrix (color × kit)
  const PRICES = {
    'Black': { 'Horn Gun Only': [365, 480], 'Horn Gun + 3Ah Battery': [395, 460], 'Horn Gun + 3Ah Battery + Charger': [425, 480] },
    'Chrome': { 'Horn Gun Only': [395, 430], 'Horn Gun + 3Ah Battery': [425, 460], 'Horn Gun + 3Ah Battery + Charger': [450, 470] },
    'Red': { 'Horn Gun Only': [365, 430], 'Horn Gun + 3Ah Battery': [395, 460], 'Horn Gun + 3Ah Battery + Charger': [425, 480] }
  };
  // base price is whatever Boss Series + Black + Horn Gun Only would be; kit options removed
  const BASE_BY_COLOR = { 'Black': [365, 480], 'Chrome': [395, 480], 'Red': [365, 480] };

  function readAccessoryTotal() {
    let extra = 0;
    document.querySelectorAll('.acc__item').forEach((item) => {
      const price = parseFloat(item.dataset.price || '0');
      const free = parseInt(item.dataset.free || '0', 10);
      const qty = parseInt(item.querySelector('input').value || '0', 10);
      const billable = Math.max(0, qty - free);
      extra += billable * price;
    });
    return extra;
  }

  function setText(sel, txt) { const el = document.querySelector(sel); if (el) el.textContent = txt; }
  function setHtml(sel, html) { const el = document.querySelector(sel); if (el) el.innerHTML = html; }
  function updatePrice() {
    const colorEl = document.getElementById('opt-color');
    const color = colorEl ? colorEl.textContent.trim() : 'Black';
    const trumpetsEl = document.getElementById('opt-trumpets');
    const trumpets = trumpetsEl ? trumpetsEl.textContent.trim() : 'Boss Series';
    const [base, baseCmp] = BASE_BY_COLOR[color] || BASE_BY_COLOR['Black'];
    const delta = TRUMPET_DELTA[trumpets] || 0;
    const accessories = readAccessoryTotal();
    const price = base + delta + accessories;
    const cmp = baseCmp + delta + accessories;
    setHtml('.price__current', `$${price}`);
    setHtml('.price__compare', `$${cmp}`);
    const save = cmp > price ? Math.round(((cmp - price) / cmp) * 100) : 0;
    setText('.price__save', `SAVE ${save}%`);
    const yousave = document.querySelector('.price__yousave');
    if (yousave) yousave.textContent = `You save $${cmp - price}`;
    setText('.cta--primary', `Add to Cart — $${price}`);
  }

  // ---------- Quantity stepper
  document.querySelectorAll('.qty__btn').forEach((b) => {
    b.addEventListener('click', () => {
      const input = document.getElementById('qty');
      const next = Math.max(1, parseInt(input.value || '1', 10) + Number(b.dataset.step));
      input.value = next;
    });
  });

  // ---------- Accessory steppers
  document.querySelectorAll('.acc__btn').forEach((b) => {
    b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      const free = parseInt(b.closest('.acc__item').dataset.free || '0', 10);
      const min = free; // can't go below the free-included quantity
      const next = Math.max(min, parseInt(input.value || '0', 10) + Number(b.dataset.step));
      input.value = next;
      updatePrice();
    });
  });

  // ---------- Testimonials carousel arrows (only when present)
  const tWrap = document.getElementById('t-carousel');
  const tPrev = document.getElementById('t-prev');
  const tNext = document.getElementById('t-next');
  if (tWrap && tPrev) tPrev.addEventListener('click', () => tWrap.scrollBy({ left: -340, behavior: 'smooth' }));
  if (tWrap && tNext) tNext.addEventListener('click', () => tWrap.scrollBy({ left: 340, behavior: 'smooth' }));

  // ---------- Sticky buy bar (product page only)
  const stickybuy = document.getElementById('stickybuy');
  const heroBuy = document.querySelector('.hero__buy');
  if (stickybuy && heroBuy) {
    function checkSticky() {
      const rect = heroBuy.getBoundingClientRect();
      if (rect.bottom < 0) stickybuy.classList.add('show');
      else stickybuy.classList.remove('show');
    }
    window.addEventListener('scroll', checkSticky, { passive: true });
    checkSticky();
  }
})();
